<template>
  <div>
    <masonry :cols="{default: 2, 700: 1}" :gutter="{default: '15px'}"
             class="masonry">
      <div>
        <div class="card">
          <h1 class="card__title">{{ $t('messages.delivery') }}</h1>
          <div class="card__description">
            <p class="font-italic mb-2">{{ $t('messages.stopped_dpd_point') }}</p>
            <b-form-group id="typeGroup">
              <b-form-radio v-model="ship" name="ship" value="home">{{ $t('messages.shipping_choose') }}</b-form-radio>
              <b-form-radio v-model="ship" name="ship" value="pickup">{{ $t('messages.pickup_choose') }}</b-form-radio>
              <b-form-radio v-model="ship" name="ship" value="combine">{{ $t('messages.shipping_combine') }}</b-form-radio>
            </b-form-group>
            <div v-if="isPickup" class="d-flex flex-column">
              <div id="orderMap"></div>
              <div v-if="pickupPoint" class="mt-3">
                <p>{{ $t('messages.pickup_chosen') }}:</p>
                <p class="font-weight-bold red">{{ pickupPoint.city }}, {{ $t('countries.' + pickupPoint.country) }}</p>
                <p class="mt-2 font-weight-bold">{{ $t('pickup.' + pickupPoint.info) }}</p>
                <p class="mt-2">{{ $t('messages.pickup_address') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="isShipping">
          <h1 class="card__title">{{ $t('messages.address_shipping') }}</h1>
          <div class="card__description">
            <b-form-group id="shippingGroup">
              <div class="mr-3 radio-width">
                <b-form-radio v-model="shipOwnAddress" name="shipping-address" :value="true">{{ $t('messages.address_existing') }}</b-form-radio>
              </div>
              <div v-if="shipOwnAddress" class="mt-3">
                <p v-if="hasAddress">
                  {{ address.firstname }} {{ address.lastname }}<br />
                  {{ address.street }} {{ address.houseNumber }}<br />
                  {{ address.postalCode }} {{ address.city }}<br />
                  {{ $t('countries.' + address.country) }}
                </p>
                <div class="alert alert-danger" v-if="!hasAddress">
                  {{ $t('errors.address_none') }}
                </div>
              </div>
              <div class="mr-3 radio-width mt-3">
                <b-form-radio v-model="shipOwnAddress" name="shipping-address" :value="false">{{ $t('messages.address_new') }}</b-form-radio>
              </div>
              <div v-if="!shipOwnAddress" class="mt-3">
                <b-form-group id="firstnameShippingGroup"
                              v-bind:label="$t('messages.firstname')+':'"
                              label-for="firstnameShipping"
                              :invalid-feedback="$t('errors.firstname')">
                  <b-form-input id="firstnameShipping" name="firstnameShipping" type="text"
                                v-model.trim="shippingAddress.firstname"
                                @input="$v.shippingAddress.firstname.$touch"
                                :state="$v.shippingAddress.firstname.$dirty ? !$v.shippingAddress.firstname.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="lastnameShippingGroup"
                              v-bind:label="$t('messages.lastname')+':'"
                              label-for="lastnameShipping"
                              :invalid-feedback="$t('errors.lastname')">
                  <b-form-input id="lastnameShipping" name="lastnameShipping" type="text"
                                v-model.trim="shippingAddress.lastname"
                                @input="$v.shippingAddress.lastname.$touch"
                                :state="$v.shippingAddress.lastname.$dirty ? !$v.shippingAddress.lastname.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="streetShippingGroup"
                              v-bind:label="$t('messages.street')+':'"
                              label-for="streetShipping"
                              :invalid-feedback="$t('errors.street')">
                  <b-form-input id="streetShipping" name="streetShipping" type="text"
                                v-model.trim="shippingAddress.street"
                                @input="$v.shippingAddress.street.$touch"
                                :state="$v.shippingAddress.street.$dirty ? !$v.shippingAddress.street.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="house_numberShippingGroup"
                              v-bind:label="$t('messages.housenumber')+':'"
                              label-for="house_numberShipping"
                              :invalid-feedback="$t('errors.housenumber')">
                  <b-form-input id="house_numberShipping" name="house_numberShipping" type="text"
                                v-model.trim="shippingAddress.houseNumber"></b-form-input>
                </b-form-group>
                <b-form-group id="postal_codeShippingGroup"
                              v-bind:label="$t('messages.postalcode')+':'"
                              label-for="postal_codeShipping"
                              :invalid-feedback="$t('errors.postalcode')">
                  <b-form-input id="postal_codeShipping" name="postal_codeShipping" type="text"
                                v-model.trim="shippingAddress.postalCode"
                                @input="$v.shippingAddress.postalCode.$touch"
                                :state="$v.shippingAddress.postalCode.$dirty ? !$v.shippingAddress.postalCode.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="locationShippingGroup"
                              v-bind:label="$t('messages.city')+':'"
                              label-for="locationShipping"
                              :invalid-feedback="$t('errors.city')">
                  <span class="small"><strong>{{ $t('messages.city_explanation') }}</strong></span>
                  <location-picker class="mt-1" :city="shippingAddress.city"
                                   :country="shippingAddress.country"
                                   :setCityAndCountry="setShippingCityAndCountry"
                                   :isValidState="($v.shippingAddress.city.$dirty || $v.shippingAddress.country.$dirty) ? (!$v.shippingAddress.city.$error && !$v.shippingAddress.country.$error) : null"></location-picker>
                </b-form-group>
              </div>
              <div class="alert alert-danger no-margin" v-if="shippingAddress.country == 'gb'">
                {{ $t('errors.delivery_gb') }}
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="card" v-if="isShipping">
          <h1 class="card__title">{{ $t('messages.contact_details') }}</h1>
          <div class="card__description">
            <b-form-group id="phoneNumberGroup"
                          v-bind:label="phoneNumberLabel"
                          label-for="phoneNumber"
                          :invalid-feedback="$t('errors.phone_number')">
              <b-form-input id="phoneNumber" name="phoneNumber" type="text"
                            v-model.trim="phoneNumber"
                            @input="$v.phoneNumber.$touch"
                            :state="$v.phoneNumber.$dirty ? !$v.phoneNumber.$error : null"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="card">
          <h1 class="card__title">{{ $t('messages.address_billing') }}</h1>
          <div class="card__description">
            <b-form-checkbox id="sameAddress" v-model="sameAddress" name="sameAddress" v-if="isShipping">
              {{ $t('messages.address_billing_same') }}
            </b-form-checkbox>
            <b-form-group id="billingGroup" v-if="!sameAddress" :class="{ 'mt-3': isShipping }">
              <div class="mr-3 radio-width">
                <b-form-radio v-model="billingOwnAddress" name="billing-address" :value="true">{{ $t('messages.address_existing') }}</b-form-radio>
              </div>
              <div v-if="billingOwnAddress" class="mt-3">
                <p v-if="hasAddress">
                  {{ address.firstname }} {{ address.lastname }}<br />
                  {{ address.street }} {{ address.houseNumber }}<br />
                  {{ address.postalCode }} {{ address.city }}<br />
                  {{ $t('countries.' + address.country) }}
                </p>
                <div class="alert alert-danger" v-if="!hasAddress">
                  {{ $t('errors.address_none') }}
                </div>
              </div>
              <div class="mr-3 radio-width mt-3">
                <b-form-radio v-model="billingOwnAddress" name="billing-address" :value="false">{{ $t('messages.address_new') }}</b-form-radio>
              </div>
              <div v-if="!billingOwnAddress" class="mt-3">
                <b-form-group id="firstnameBillingGroup"
                              v-bind:label="$t('messages.firstname')+':'"
                              label-for="firstnameBilling"
                              :invalid-feedback="$t('errors.firstname')">
                  <b-form-input id="firstnameBilling" name="firstnameBilling" type="text"
                                v-model.trim="billingAddress.firstname"
                                @input="$v.billingAddress.firstname.$touch"
                                :state="$v.billingAddress.firstname.$dirty ? !$v.billingAddress.firstname.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="lastnameBillingGroup"
                              v-bind:label="$t('messages.lastname')+':'"
                              label-for="lastnameBilling"
                              :invalid-feedback="$t('errors.lastname')">
                  <b-form-input id="lastnameBilling" name="lastnameBilling" type="text"
                                v-model.trim="billingAddress.lastname"
                                @input="$v.billingAddress.lastname.$touch"
                                :state="$v.billingAddress.lastname.$dirty ? !$v.billingAddress.lastname.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="streetBillingGroup"
                              v-bind:label="$t('messages.street')+':'"
                              label-for="streetBilling"
                              :invalid-feedback="$t('errors.street')">
                  <b-form-input id="streetBilling" name="streetBilling" type="text"
                                v-model.trim="billingAddress.street"
                                @input="$v.billingAddress.street.$touch"
                                :state="$v.billingAddress.street.$dirty ? !$v.billingAddress.street.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="house_numberBillingGroup"
                              v-bind:label="$t('messages.housenumber')+':'"
                              label-for="house_numberBilling"
                              :invalid-feedback="$t('errors.housenumber')">
                  <b-form-input id="house_numberBilling" name="house_numberBilling" type="text"
                                v-model.trim="billingAddress.houseNumber"></b-form-input>
                </b-form-group>
                <b-form-group id="postal_codeBillingGroup"
                              v-bind:label="$t('messages.postalcode')+':'"
                              label-for="postal_codeBilling"
                              :invalid-feedback="$t('errors.postalcode')">
                  <b-form-input id="postal_codeBilling" name="postal_codeBilling" type="text"
                                v-model.trim="billingAddress.postalCode"
                                @input="$v.billingAddress.postalCode.$touch"
                                :state="$v.billingAddress.postalCode.$dirty ? !$v.billingAddress.postalCode.$error : null"></b-form-input>
                </b-form-group>
                <b-form-group id="locationBillingGroup"
                              v-bind:label="$t('messages.city')+':'"
                              label-for="locationBilling"
                              :invalid-feedback="$t('errors.city')">
                  <span class="small"><strong>{{ $t('messages.city_explanation') }}</strong></span>
                  <location-picker :city="billingAddress.city"
                                   :country="billingAddress.country"
                                   :setCityAndCountry="setBillingCityAndCountry"
                                   :isValidState="($v.billingAddress.city.$dirty || $v.billingAddress.country.$dirty) ? (!$v.billingAddress.city.$error && !$v.billingAddress.country.$error) : null"></location-picker>
                </b-form-group>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="card no-margin">
          <h1 class="card__title">{{ $t('messages.payment_method') }}</h1>
          <div class="card__description">
            <div>
              <b-form-group>
                <b-form-radio v-model="paymentMethod" name="payment-method" value="bancontact" class="custom-radio-payment">
                  <div class="d-flex align-items-center">
                    <div class="pl-1 logo-div d-flex justify-content-center">
                      <img src="../../assets/payment/bancontact.png" class="logo" />
                    </div>
                    <div class="pl-2">{{ $t('payments.bancontact') }}</div>
                  </div>
                </b-form-radio>
                <b-form-radio v-model="paymentMethod" name="payment-method" value="ideal" class="custom-radio-payment">
                  <div class="d-flex align-items-center">
                    <div class="pl-1 logo-div d-flex justify-content-center">
                      <img src="../../assets/payment/ideal.png" class="logo" />
                    </div>
                    <div class="pl-2">{{ $t('payments.ideal') }}</div>
                  </div>
                </b-form-radio>
                <b-form-radio v-model="paymentMethod" name="payment-method" value="paypal" class="custom-radio-payment">
                  <div class="d-flex align-items-center">
                    <div class="pl-1 logo-div d-flex justify-content-center">
                      <font-awesome-icon :icon="['fab', 'paypal']" class="red logo w-100"></font-awesome-icon>
                    </div>
                    <div class="pl-2">{{ $t('payments.paypal') }} (+5%)</div>
                  </div>
                </b-form-radio>
                <b-form-radio v-model="paymentMethod" name="payment-method" value="creditcard" class="custom-radio-payment">
                  <div class="d-flex align-items-center">
                    <div class="pl-1 logo-div d-flex justify-content-center">
                      <font-awesome-icon icon="credit-card" class="red logo w-100"></font-awesome-icon>
                    </div>
                    <div class="pl-2">{{ $t('payments.creditcard') }} (+2%)</div>
                  </div>
                </b-form-radio>
                <b-form-radio v-model="paymentMethod" name="payment-method" value="transfer" class="custom-radio-payment">
                  <div class="d-flex align-items-center">
                    <div class="pl-1 logo-div d-flex justify-content-center">
                      <font-awesome-icon icon="money-check-alt" class="red logo w-100"></font-awesome-icon>
                    </div>
                    <div class="pl-2">{{ $t('payments.transfer') }} (+1-3 {{ $t('messages.working_days') }})</div>
                  </div>
                </b-form-radio>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="sticky-top">
        <div class="card">
          <h1 class="card__title">{{ $t('messages.overview') }}</h1>
          <div class="card__description border-0">
            <b-table striped bordered stacked="md" :items="items" :fields="fields">
              <template v-slot:cell(image)="row">
                <b-img :src="row.item.image" fluid :alt="row.item.name" @click="navigateToProduct(row.item)" class="pointer" />
              </template>

              <template v-slot:cell(price)="row">
                € {{ row.item.price | round(2) }}
              </template>

              <template v-slot:cell(total)="row">
                € {{ (row.item.amount * row.item.price) | round(2) }}
              </template>
            </b-table>
            <div class="d-flex justify-content-end mr-1 mb-2 font-weight-bold font-italic" v-if="isShipping && (subTotalSum < 100)">
              <p v-if="isShippingNLBE">{{ $t('messages.shipping_discount_short_pre') }} € {{ (100 - subTotalSum) | round(2) }} {{ $t('messages.shipping_discount_short_post_nlbe') }}</p>
              <p v-if="!isShippingNLBE">{{ $t('messages.shipping_discount_short_pre') }} € {{ (100 - subTotalSum) | round(2) }} {{ $t('messages.shipping_discount_short_post_abroad') }}</p>
            </div>
            <div class="d-flex">
              <div class="d-flex flex-column w-100">
                <div class="d-flex flex-column w-100 mb-3">
                  <p class="font-weight-bold">{{ $t('messages.coupon_code') }}</p>
                  <div class="d-flex">
                    <b-form @submit.prevent="applyCouponCode" class="w-100" v-if="!couponDiscount">
                      <b-form-input id="couponCode" name="couponCode" type="text"
                                    v-model.trim="couponCode"></b-form-input>
                      <notification-button :message="$t('messages.apply')" :notification="notifications.couponCode" field="couponCode" class="mt-1 float-right"></notification-button>
                    </b-form>
                    <div class="d-flex" v-if="couponDiscount">
                      <p class="mr-2">{{ couponCode }}</p>
                      <b-button v-b-tooltip.hover :title="$t('messages.coupon_code_delete')" variant="transparent" @click="deleteCouponCode()" class="bg-transparent p-0 mt-m-1" size="sm">
                        <font-awesome-icon icon="trash-alt" class="red"></font-awesome-icon>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column align-items-end w-100">
                <p class="mr-1">
                  <span class="font-weight-bold">{{ $t('messages.total_sub') }}</span>: € {{ subTotalSum | round(2) }}
                </p>
                <p class="mr-1 red">
                  <span class="font-weight-bold">{{ !isPickup ? $t('messages.shipping_costs') : $t('messages.pickup_costs') }}</span>:
                  € {{ shippingPrice ? shippingPrice : 0 | round(2) }}
                </p>
                <p class="mr-1 mt-2 red" v-if="discountSum > 0">
                  <span class="font-weight-bold">{{ $t('messages.discount') }}</span>: € {{ discountSum ? discountSum : 0 | round(2) }}
                </p>
                <p class="mr-1 mt-2 red" v-if="paymentMethod === 'paypal'">
                  <span class="font-weight-bold">{{ $t('messages.extra_costs') }}</span>: € {{ paypalSum | round(2) }}
                </p>
                <p class="mr-1 mt-2 red" v-if="paymentMethod === 'creditcard'">
                  <span class="font-weight-bold">{{ $t('messages.extra_costs') }}</span>: € {{ creditCardSum | round(2) }}
                </p>
                <p class="mr-1 mt-2">
                  <span class="font-weight-bold">{{ $t('messages.total') }}</span>: € {{ (totalSum + paypalSum + creditCardSum) | round(2) }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-column w-100 mb-3">
              <p class="font-weight-bold">{{ $t('messages.comments') }}</p>
              <div class="d-flex">
                <b-form-textarea id="comments" name="comments" rows="3" :placeholder="$t('messages.comments_info')"
                                 v-model.trim="comments" class="mb-2"></b-form-textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-responsive">
          <div class="card w-100 no-margin">
            <h1 class="card__title">{{ $t('messages.expected_delivery') }}</h1>
            <div class="card__description border-0">
              <div v-if="isShipping">
                <p class="green strong" v-if="expectedDeliveryDate">
                  {{ translatedExpectedDeliveryDate }}
                </p>
                <p class="mt-2 font-italic" v-if="expectedDelayedDeliveryDate">
                  {{ $t('messages.shipping_not_complete') }}
                </p>
              </div>
              <div v-if="isPickup && (!pickupPoint || pickupPoint && pickupPoint.id > 1)">
                <p class="font-italic">
                  {{ $t('messages.pickup_address_date') }}
                </p>
              </div>
              <div v-if="isPickup && pickupPoint && pickupPoint.id === 1">
                <p class="green strong">
                  {{ $t('messages.pickup_address_date_main') }}
                </p>
              </div>
              <div v-if="isCombine">
                <p class="font-italic">
                  {{ $t('messages.combine_date') }}
                </p>
              </div>
              <p class="mt-2 font-italic">
                {{ $t('messages.shipping_external_factors') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </masonry>
    <div class="card__wrapper">
      <div class="card">
        <div class="card__description pt-20">
          <div class="d-flex">
            <div>
              <b-button variant="primary" @click="backToCart">{{ $t('messages.go_back') }}</b-button>
            </div>
            <div class="ml-auto">
              <b-form @submit.prevent="order">
                <notification-button :message="$t('messages.order_place')" :notification="notifications.order" field="order" :instant="true"
                                     :disabled="!isValid || $v.$invalid"></notification-button>
              </b-form>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <p class="font-italic">{{ $t('messages.order_mandatory_pre') }} <b-button variant="link" class="buttonNoPadding font-italic" v-b-modal.termsModal>{{ $t('messages.order_mandatory_terms').toLowerCase() }}</b-button> {{ $t('messages.order_mandatory_post') }}</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="termsModal" :title="$t('messages.terms_conditions')" hide-footer>
      <p v-html="getTerms()"></p>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import _ from 'lodash'
import LocationPicker from '../../components/LocationPicker'

import NotificationButton from '../../components/NotificationButton'

import { productService } from '../../services/product.service'
import { userService } from '../../services/user.service'
import { orderService } from '../../services/order.service'
import { daysService } from '../../services/days.service'

import { defaultMixin } from '../../mixin/default'
import { validationMixin } from 'vuelidate'
import { notificationMixin } from '../../mixin/notification'

import { required, requiredIf, sameAs } from 'vuelidate/lib/validators'

Vue.use(VueMasonry)

export default {
  name: 'delivery',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.delivery') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.delivery'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: { LocationPicker, NotificationButton },
  mixins: [ defaultMixin, validationMixin, notificationMixin ],
  data: function () {
    return {
      store: false,
      ship: null,
      pickupPoints: null,
      pickupPoint: null,
      map: {
        timeout: null
      },
      phoneNumber: null,
      sameAddress: true,
      shipOwnAddress: true,
      billingOwnAddress: true,
      address: {
        firstname: null,
        lastname: null,
        street: null,
        houseNumber: null,
        postalCode: null,
        city: null,
        country: null
      },
      shippingAddress: {
        pickup: null,
        firstname: null,
        lastname: null,
        street: null,
        houseNumber: null,
        postalCode: null,
        city: null,
        country: null
      },
      billingAddress: {
        firstname: null,
        lastname: null,
        street: null,
        houseNumber: null,
        postalCode: null,
        city: null,
        country: null
      },
      paymentMethod: null,
      fields: [{
        key: 'image',
        label: this.$i18n.t('messages.image'),
        tdClass: 'td-image'
      }, {
        key: 'name',
        label: this.$i18n.t('messages.name')
      }, {
        key: 'amount',
        label: this.$i18n.t('messages.number'),
        tdClass: 'td-info'
      }, {
        key: 'price',
        label: this.$i18n.t('messages.price'),
        tdClass: 'td-info'
      }, {
        key: 'total',
        label: this.$i18n.t('messages.total'),
        tdClass: 'td-info'
      }],
      amounts: this.$store.state.orders.map(order => order.amount),
      couponCode: null,
      couponDiscount: null,
      comments: null,
      shippingPrice: null,
      expectedDeliveryDate: null,
      expectedDelayedDeliveryDate: null,
      notifications: {
        order: null,
        couponCode: null
      }
    }
  },
  validations: function () {
    return {
      store: {
        sameAs: sameAs(() => false)
      },
      pickupPoint: {
        required: requiredIf(function (value) {
          return this.isPickup
        })
      },
      phoneNumber: {
        required: requiredIf(function (value) {
          return this.isShippingScandinavian
        })
      },
      shippingAddress: {
        firstname: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        },
        lastname: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        },
        street: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        },
        postalCode: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        },
        city: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        },
        country: {
          required: requiredIf(function (value) {
            return this.isShipping
          })
        }
      },
      billingAddress: {
        firstname: {
          required
        },
        lastname: {
          required
        },
        street: {
          required
        },
        postalCode: {
          required
        },
        city: {
          required
        },
        country: {
          required
        }
      },
      paymentMethod: {
        required
      }
    }
  },
  computed: {
    mapIcon: function () {
      return Vue.prototype.$hostname.concat('/image/arrow-orange.png')
    },
    hasAddress: function () {
      return !!this.address.street && !!this.address.postalCode && !!this.address.city && !!this.address.country
    },
    items: function () {
      let hasDanger = false
      let items = this.$store.state.orders
      items.forEach(function (item) {
        if (!item.preorder && !item.backorder && (item.amount > item.stock)) {
          item._rowVariant = 'danger'
          hasDanger = true
        } else {
          item._rowVariant = null
        }
      })
      if (hasDanger) {
        this.$store.commit('error', 'errors.stock_exhausted_overview')
      } else {
        this.$store.commit('clear')
      }
      return items
    },
    isValid: function () {
      let isValid = true
      if (isValid) {
        this.$store.state.orders.forEach(function (item) {
          if (!item.preorder && !item.backorder && (item.amount > item.stock)) {
            isValid = false
          }
        })
      }
      if (isValid) {
        isValid = this.shippingPrice >= 0
      }
      return isValid
    },
    isShipping: function () {
      return this.ship === 'home'
    },
    isShippingNLBE: function () {
      return this.isShipping && ['nl', 'be'].includes(this.shippingAddress.country)
    },
    isShippingScandinavian: function () {
      return ['dk', 'se', 'fi'].includes(this.shippingAddress.country)
    },
    isPickup: function () {
      return this.ship === 'pickup'
    },
    isCombine: function () {
      return this.ship === 'combine'
    },
    isBankTransfer: function () {
      return this.paymentMethod === 'transfer'
    },
    subTotalSum: function () {
      return this.$store.state.orders.map(order => order.amount * order.price).reduce((a, b) => a + b, 0)
    },
    discountSum: function () {
      if (this.couponDiscount) {
        return this.couponDiscount
      } else if (this.$store.state.discounted) {
        return this.$store.state.orders.filter(order => !order.orderedBefore).map(order => order.price - order.reducedPrice).reduce((a, b) => a + b, 0)
      } else {
        return null
      }
    },
    totalSum: function () {
      return this.subTotalSum + (this.shippingPrice ? this.shippingPrice : 0) - (this.discountSum ? this.discountSum : 0)
    },
    shippingSum: function () {
      return this.subTotalSum - (this.discountSum ? this.discountSum : 0)
    },
    paypalSum: function () {
      return this.paymentMethod === 'paypal' ? this.totalSum * 0.05 : 0
    },
    creditCardSum: function () {
      return this.paymentMethod === 'creditcard' ? this.totalSum * 0.02 : 0
    },
    extraWorkingDayCountry: function () {
      return ['be', 'nl'].includes(this.shippingAddress.country)
    },
    phoneNumberLabel: function () {
      return this.$i18n.t('messages.phone_number') + ' (' + (this.isShippingScandinavian ? this.$i18n.t('messages.mandatory') : this.$i18n.t('messages.mandatory_not')) + '):'
    },
    formatExpectedDeliveryDate: function () {
      if (this.expectedDelayedDeliveryDate === null) {
        return this.expectedDeliveryDate.getDay() + '-' + this.expectedDeliveryDate.getDate() + '-' + (this.expectedDeliveryDate.getMonth() + 1) + '-' + this.expectedDeliveryDate.getFullYear()
      } else {
        return (this.expectedDelayedDeliveryDate.getMonth() + 1) + '-' + this.expectedDelayedDeliveryDate.getFullYear()
      }
    },
    translatedExpectedDeliveryDate: function () {
      if (this.expectedDelayedDeliveryDate === null) {
        let translatedDate = this.translateDate(this.expectedDeliveryDate.getFullYear() + '-' + (this.expectedDeliveryDate.getMonth() + 1) + '-' + this.expectedDeliveryDate.getDate()).split(' ')
        return this.translateDay(this.expectedDeliveryDate.getDay()) + ' ' + translatedDate[0] + ' ' + translatedDate[1] + ' ' + translatedDate[2]
      } else {
        let translatedDate = this.translateDate(this.expectedDelayedDeliveryDate.getFullYear() + '-' + (this.expectedDelayedDeliveryDate.getMonth() + 1) + '-' + this.expectedDelayedDeliveryDate.getDate()).split(' ')
        return translatedDate[1] + ' ' + translatedDate[2]
      }
    }
  },
  methods: {
    setShippingCityAndCountry: function (city, country, lat, lng) {
      this.$set(this.shippingAddress, 'city', city)
      this.$set(this.shippingAddress, 'country', country)
      this.$v.shippingAddress.city.$touch()
      this.$v.shippingAddress.country.$touch()
    },
    setBillingCityAndCountry: function (city, country, lat, lng) {
      this.$set(this.billingAddress, 'city', city)
      this.$set(this.billingAddress, 'country', country)
      this.$v.billingAddress.city.$touch()
      this.$v.billingAddress.country.$touch()
    },
    fillShipOwnAddress: function () {
      if (this.shipOwnAddress && this.hasAddress) {
        this.shippingAddress.firstname = this.address.firstname
        this.shippingAddress.lastname = this.address.lastname
        this.shippingAddress.street = this.address.street
        this.shippingAddress.houseNumber = this.address.houseNumber
        this.shippingAddress.postalCode = this.address.postalCode
        this.shippingAddress.city = this.address.city
        this.shippingAddress.country = this.address.country
      } else {
        this.clearShippingAddress()
      }
      if (this.sameAddress) {
        this.fillBillingOwnAddress()
      }
    },
    fillBillingOwnAddress: function () {
      if (this.billingOwnAddress && this.hasAddress) {
        this.billingAddress.firstname = this.address.firstname
        this.billingAddress.lastname = this.address.lastname
        this.billingAddress.street = this.address.street
        this.billingAddress.houseNumber = this.address.houseNumber
        this.billingAddress.postalCode = this.address.postalCode
        this.billingAddress.city = this.address.city
        this.billingAddress.country = this.address.country
      } else {
        this.billingAddress.firstname = null
        this.billingAddress.lastname = null
        this.billingAddress.street = null
        this.billingAddress.houseNumber = null
        this.billingAddress.postalCode = null
        this.billingAddress.city = null
        this.billingAddress.country = null
        this.$v.billingAddress.$reset()
      }
    },
    initializeMap: _.debounce(function () {
      if (this.pickupPoints && this.pickupPoints.length > 0) {
        let container = document.getElementById('orderMap')
        if (container) {
          let self = this
          // eslint-disable-next-line no-undef
          let map = new L.Map('orderMap', {
            fullscreenControl: true,
            center: [0, 0],
            zoom: 10
          })
          let markers = []
          // eslint-disable-next-line no-undef
          let mapIcon = L.icon({
            iconUrl: this.mapIcon,
            iconSize: [25, 30]
          })
          this.pickupPoints.forEach(function (pickupPoint) {
            // eslint-disable-next-line no-undef
            let marker = new L.Marker([pickupPoint.lat, pickupPoint.lng], {
              icon: mapIcon,
              title: pickupPoint.city + ', ' + self.$i18n.t('countries.' + pickupPoint.country),
              pickupPoint: pickupPoint
            })
            marker.on('click', function (e) {
              self.pickupPoint = e.sourceTarget.options.pickupPoint
            })
            marker.addTo(map)
            markers.push(marker)
          })
          // eslint-disable-next-line no-undef
          let group = new L.FeatureGroup(markers)
          map.fitBounds(group.getBounds(), {
            padding: [50, 50]
          })
          // eslint-disable-next-line no-undef, no-template-curly-in-string
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(map)
          this.map.initialized = true
        }
      }
    }, 500),
    clearShippingAddress: function () {
      this.shippingAddress.firstname = null
      this.shippingAddress.lastname = null
      this.shippingAddress.street = null
      this.shippingAddress.houseNumber = null
      this.shippingAddress.postalCode = null
      this.shippingAddress.city = null
      this.shippingAddress.country = null
      this.$v.shippingAddress.$reset()
    },
    backToCart: function () {
      this.$router.push('/cart')
    },
    navigateToProduct: function (product) {
      this.$router.push('/product/' + this.slugText(product.id + '/' + product.name))
    },
    deleteCouponCode: function () {
      this.couponDiscount = null
      this.couponCode = null
      this.resetNotification('couponCode')
    },
    click: function (id) {
      document.getElementById(id).click()
    },
    updateCart: function () {
      let loader = this.$loading.show()
      if (this.$store.state.orders && this.$store.state.orders.length > 0) {
        let self = this
        let counter = 0
        let total = this.$store.state.orders.length
        this.$store.state.orders.forEach(function (order) {
          productService.get(order.id)
            .then((product) => {
              order.preorder = product.preorder
              order.backorder = product.backorder
              order.stock = product.stock
              order.price = product.price
              order.reducedPrice = product.reduced_price
              order.orderedBefore = product.ordered_before
              let expectedDate = product.expected_date
              if (expectedDate !== null) {
                expectedDate = expectedDate.split('-')
                let delayedExpectedDate = new Date(expectedDate[1], (expectedDate[0] - 1))
                if (self.expectedDelayedDeliveryDate === null || delayedExpectedDate > self.expectedDelayedDeliveryDate) {
                  self.expectedDelayedDeliveryDate = delayedExpectedDate
                }
              }

              counter++

              if (counter === total) {
                loader.hide()
              }
            }, () => {
              loader.hide()
            })
        })
      } else {
        loader.hide()
      }
    },
    updateShippingPrice: function () {
      let loader = this.$loading.show()
      if (this.isShipping && !!this.shippingAddress.country) {
        productService.fetchShippingPrice(this.shippingAddress.country)
          .then((shippingPrice) => {
            if (this.shippingSum < 100.00) {
              this.shippingPrice = shippingPrice.price
            } else {
              let newPrice = shippingPrice.price - this.$store.state.shippingDiscount
              if (newPrice <= 0.00) {
                newPrice = 0.00
              }
              this.shippingPrice = newPrice
            }
            loader.hide()
          }, () => {
            this.shippingPrice = null
            loader.hide()
          })
      } else {
        this.shippingPrice = null
        loader.hide()
      }
    },
    applyCouponCode: function () {
      let couponCode = this.couponCode
      orderService.fetchCouponCodeInfo(couponCode)
        .then((response) => {
          let type = response.type
          let amount = response.amount
          let remainingAmount = response.remaining_amount
          let minimumValue = response.minimum_value
          if (minimumValue === null || (minimumValue && this.subTotalSum >= minimumValue)) {
            if (type === 'value') {
              this.couponDiscount = remainingAmount
            } else if (type === 'percent') {
              this.couponDiscount = parseFloat(Vue.options.filters.round(((amount / 100) * this.subTotalSum), 2))
            }
            this.$store.commit('success', 'success.coupon_code')
            this.sendNotification('couponCode', 'success')
          } else {
            this.sendNotification('couponCode', 'error')
            this.$store.commit('error', 'errors.coupon_code_minimum')
          }
          this.updateCart()
          this.updateShippingPrice()
        }, () => {
          this.sendNotification('couponCode', 'error')
          this.$store.commit('error', 'errors.coupon_code')
          this.updateCart()
          this.updateShippingPrice()
        })
    },
    order: function () {
      let items = this.$store.state.orders
      let paymentMethod = this.paymentMethod
      let comments = this.comments
      let couponCode = this.couponCode
      let pickupPoint = this.isPickup && this.pickupPoint ? this.pickupPoint.id : null
      let shippingAddress = this.isShipping ? this.shippingAddress : null
      let phoneNumber = this.phoneNumber
      let billingAddress = this.billingAddress
      orderService.create(items, paymentMethod, comments, couponCode, true, pickupPoint, this.formatExpectedDeliveryDate, shippingAddress, phoneNumber, billingAddress, this.shippingPrice, this.discountSum)
        .then((response) => {
          window.location.href = response.href
        }, () => {
          this.sendNotification('order', 'error')
          this.$store.commit('error', 'errors.order')
          this.updateCart()
        })
    },
    calculateNextDeliveryDate: function () {
      if (this.isShipping && !!this.shippingAddress.country) {
        daysService.getNextDeliveryDay(this.shippingAddress.country, false)
          .then((response) => {
            this.expectedDeliveryDate = response

            if (this.isBankTransfer) {
              this.expectedDeliveryDate.setDate(this.expectedDeliveryDate.getDate() + 3)
              if (this.expectedDeliveryDate.getDay() === 0) {
                this.expectedDeliveryDate.setDate(this.expectedDeliveryDate.getDate() + 2)
              }
            }
          }, () => {
            this.sendNotification('order', 'error')
            this.$store.commit('error', 'errors.delivery')
            this.updateCart()
          })
      }
    },
    getTerms: function () {
      let termsUrl = 'i18n/terms/' + this.$i18n.locale + '.html'
      return require('@/' + termsUrl)
    }
  },
  watch: {
    sameAddress: function () {
      if (this.sameAddress) {
        this.billingAddress.firstname = this.shippingAddress.firstname
        this.billingAddress.lastname = this.shippingAddress.lastname
        this.billingAddress.street = this.shippingAddress.street
        this.billingAddress.houseNumber = this.shippingAddress.houseNumber
        this.billingAddress.postalCode = this.shippingAddress.postalCode
        this.billingAddress.city = this.shippingAddress.city
        this.billingAddress.country = this.shippingAddress.country
      } else {
        this.billingOwnAddress = true
        this.fillBillingOwnAddress()
      }
    },
    shipOwnAddress: function () {
      this.fillShipOwnAddress()
      this.phoneNumber = null
    },
    'shippingAddress.firstname': function () {
      if (this.sameAddress) {
        this.billingAddress.firstname = this.shippingAddress.firstname
      }
    },
    'shippingAddress.lastname': function () {
      if (this.sameAddress) {
        this.billingAddress.lastname = this.shippingAddress.lastname
      }
    },
    'shippingAddress.street': function () {
      if (this.sameAddress) {
        this.billingAddress.street = this.shippingAddress.street
      }
    },
    'shippingAddress.houseNumber': function () {
      if (this.sameAddress) {
        this.billingAddress.houseNumber = this.shippingAddress.houseNumber
      }
    },
    'shippingAddress.postalCode': function () {
      if (this.sameAddress) {
        this.billingAddress.postalCode = this.shippingAddress.postalCode
      }
    },
    'shippingAddress.city': function () {
      if (this.sameAddress) {
        this.billingAddress.city = this.shippingAddress.city
      }
    },
    'shippingAddress.country': function () {
      if (this.sameAddress) {
        this.billingAddress.country = this.shippingAddress.country
      }
      this.updateShippingPrice()
      this.calculateNextDeliveryDate()
      this.phoneNumber = null
    },
    billingOwnAddress: function () {
      this.fillBillingOwnAddress()
    },
    ship: function () {
      if (!this.isShipping) {
        this.initializeMap()
        this.sameAddress = false
        this.clearShippingAddress()
      } else {
        this.pickupPoint = null
        this.sameAddress = true
        this.fillShipOwnAddress()
      }
      this.updateShippingPrice()
      this.calculateNextDeliveryDate()
    },
    paymentMethod: function () {
      this.calculateNextDeliveryDate()
    }
  },
  mounted: function () {
    let self = this
    window.addEventListener('resize', function () {
      if (self.map.timeout) {
        clearTimeout(self.map.timeout)
      }
      self.map.timeout = setTimeout(function () {
        self.initializeMap()
      }, 1000)
    })
  },
  created: function () {
    let loader = this.$loading.show()
    productService.fetchPickupPoints()
      .then((pickupPoints) => {
        this.pickupPoints = pickupPoints

        if (this.isPickup) {
          this.initializeMap()
        }

        userService.get()
          .then((user) => {
            this.store = user.store

            if (this.store) {
              this.$store.commit('error', 'errors.customers_private')
            }

            this.address.firstname = user.firstname
            this.address.lastname = user.lastname
            this.address.street = user.street
            this.address.houseNumber = user.house_number
            this.address.postalCode = user.postal_code
            this.address.city = user.city
            this.address.country = user.country

            loader.hide()
            this.ship = 'home'

            // Update cart
            this.updateCart()
          }, () => {
            this.$store.commit('error', 'errors.address')
            loader.hide()
          })
      }, () => {
        this.$store.commit('error', 'errors.pickup_points')
        loader.hide()
      })

    let self = this
    this.$root.$on('resetNotification', (notification) => {
      self.resetNotification(notification)
    })
  },
  beforeDestroy: function () {
    clearTimeout(this.map.timeout)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .masonry {
    padding: 10px;
  }

  .radio-width {
    width: 200px;
  }

  #orderMap {
    width: 100%;
    height: 300px;
  }

  .form-group >>> .custom-radio-payment .custom-control-label::before, .form-group >>> .custom-radio-payment .custom-control-label::after {
    top: 9px !important;
  }

  .logo-div {
    width: 60px;
  }

  .logo {
    height: 35px;
  }

  .sticky-top {
    margin-top: 20px;
  }

  .table >>> td {
    vertical-align: middle !important;
  }

  .table >>> .td-image img {
    max-height: 100px !important;
  }

  @media screen and (min-width: 768px) {
    #orderMap {
      width: 500px;
    }

    .sticky-top {
      margin-top: 0px;
    }

    .table >>> .td-image {
      width: 150px !important;
      text-align: center;
    }

    .table >>> .td-info {
      width: 150px !important;
    }
  }

  .buttonNoPadding {
    margin: -2px 0px 0px;
    padding: 0px;
    font-size: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/Delivery.vue